import React from 'react';
import { ClientSongCollection, postClientSongCollection, uploadSongCollectionImage } from '@round/api';
import SongCollectionForm, { SongCollectionFormProps } from '../SongCollectionForm/SongCollectionForm';
import { showNotification } from '../../../../../helpers';
import { Modal, ModalContent, ModalTitle } from '@round/ui-kit';
import styles from './CreateClientSongCollectionModal.module.css';

type CreateClientSongCollectionModalProps = {
    clientId: number;
    isOpen: boolean;
    onClose: () => void;
    onCreated: (collection: ClientSongCollection) => void;
};

const CreateClientSongCollectionModal = ({
    onCreated,
    clientId,
    onClose,
    isOpen,
}: CreateClientSongCollectionModalProps) => {
    const handleSubmit: SongCollectionFormProps['handleSubmit'] = async (values, { setSubmitting }) => {
        try {
            setSubmitting(true);
            const response = await postClientSongCollection(clientId, { name: values.name });
            if (response.status !== 201) {
                showNotification('Could not create song collection', 'error');
                return;
            }

            const [image] = values.image;
            if (!image) {
                onCreated(response.data);
                showNotification('Song collection created', 'info');
                return;
            }

            const imageResponse = await uploadSongCollectionImage(response.data.id, image);
            if (imageResponse.status === 404) {
                showNotification(imageResponse.data.detail, 'error');
                return;
            }

            onCreated(response.data);
            showNotification('Song collection created', 'info');
        } catch {
            showNotification('Could not creat song collection', 'error');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal closeOnOverlayClick isOpen={isOpen} onClose={onClose} className={styles.modal}>
            <ModalTitle>Create Song Collection</ModalTitle>
            <ModalContent>
                <SongCollectionForm handleSubmit={handleSubmit} />
            </ModalContent>
        </Modal>
    );
};

export default CreateClientSongCollectionModal;
